// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1cEdB","right":"Footer_right__4lKKe","buttons":"Footer_buttons__1VNe3"};